import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { type TemplateViewData } from 'garaje/pods/components/announcement-template/announcement-template-list/component';

interface AnnouncementFeedItemArgs {
  template: TemplateViewData;
}

export default class AnnouncementFeedItem extends Component<AnnouncementFeedItemArgs> {
  @service declare router: RouterService;

  get popoverLocations(): string[] {
    return this.args.template.remainingLocations.slice(0, 15);
  }

  get remainingPopoverLocationsCount(): number {
    return this.args.template.remainingLocations.length - 15;
  }

  // List renders under both `communications.templates.list` (per-location) and
  // `location-overview.communications.templates.list` (global overview). Route the
  // row click to the matching edit screen so a global-overview user doesn't get
  // pulled into a `current-location` context (SQ-7332).
  get editRoute(): string {
    return this.router.currentRouteName?.includes('location-overview')
      ? 'location-overview.communications.templates.edit'
      : 'communications.templates.edit';
  }
}
